<template>
  <div id="branch-create" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="closeSnackbar" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock
              :headerText="editMode ? 'Edit Branch' : 'Create Branch'"
            />
            <v-row>
              <!-- Branch Code -->
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Branch Code</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.code"
                  required
                  clearable
                  placeholder="Enter Branch Code"
                ></v-text-field>
              </v-col>

              <!-- Branch Name -->
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Branch Name</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.name"
                  required
                  clearable
                  placeholder="Enter Branch Name"
                ></v-text-field>
              </v-col>

              <!-- Status -->
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Status</p>
                </v-col>
                <v-select
                  outlined
                  dense
                  v-model="form.status"
                  required
                  clearable
                  placeholder="Select Status"
                  :items="statuses"
                ></v-select>
              </v-col>
            </v-row>

            <!-- Submit Button -->
            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                    v-if="
                      (editMode && hasPermission('branch.edit')) ||
                        (!editMode && hasPermission('branch.create'))
                    "
                  >
                    {{ editMode ? "Update Branch" : "Create Branch" }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { BranchService } from "@/services/branch-service.js";
import { checkError } from "@/config/errors.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "BranchForm",
  components: {
    Alert,
    Snackbars,
    HeaderDividerBlock,
  },
  props: {
    editMode: { type: Boolean, default: false },
    branchId: { type: [String, Number], default: null },
  },
  data() {
    return {
      loading: false,
      errors: null,
      snackbar: false,
      succesMsg: "",
      form: {
        code: "",
        name: "",
        status: "ACTIVE",
      },
      statuses: ["ACTIVE", "INACTIVE"],
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  created() {
    if (this.editMode && this.branchId) {
      this.fetchBranchDetails();
    }
  },
  methods: {
    async fetchBranchDetails() {
      this.loading = true;
      try {
        const response = await BranchService.getBranchById(this.branchId);
        this.form = response.data;
      } catch (error) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      this.loading = true;
      this.errors = null;
      try {
        if (this.editMode) {
          await BranchService.updateBranch(this.form, this.branchId);
          this.succesMsg = "Branch updated successfully!";
        } else {
          await BranchService.createBranch(this.form);
          this.succesMsg = "Branch created successfully!";
          this.resetForm();
        }
        this.snackbar = true;
      } catch (error) {
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
        this.snackbarError = true;
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.form = {
        code: "",
        name: "",
        status: "ACTIVE",
      };
    },
    closeSnackbar() {
      this.snackbar = false;
      this.errors = null;
    },
  },
};
</script>
